var option_default = {
  "option": "StwHN",
  "user_choice": "a8-yy",
  "check": "Po439",
  "image": "NYuA-",
  "input": "HLw0t",
  "title": "ltWQc",
  "centered": "jvISE",
  "with_result": "_2QQBF",
  "list": "_7wlSg",
  "with_image": "fReFc",
  "progress": "KKSVW",
  "progress_value": "l3uJ5",
  "label": "Bnhfk",
  "cta": "_7tLEj",
  "adornment_icon": "mBsLd",
  "remove": "d94d6",
  "removeButton": "ZASTC",
  "removeButtonIcon": "PMZ6E",
  "overlay": "on1mM",
  "shown": "tH7mv",
  "dark": "QW0GD",
  "spinner": "deQUf",
  "spin": "QGjeI"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
